/* tslint:disable */
/* eslint-disable */
/**
 * GLC.ClientPortal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface InvestmentComponentsViewModel
 */
export interface InvestmentComponentsViewModel {
    /**
     * 
     * @type {number}
     * @memberof InvestmentComponentsViewModel
     */
    vestedComponentNonVestedRights?: number;
    /**
     * 
     * @type {number}
     * @memberof InvestmentComponentsViewModel
     */
    nonVestedComponent?: number;
    /**
     * 
     * @type {number}
     * @memberof InvestmentComponentsViewModel
     */
    retirementComponent?: number;
    /**
     * 
     * @type {number}
     * @memberof InvestmentComponentsViewModel
     */
    savingsComponent?: number;
}

/**
 * Check if a given object implements the InvestmentComponentsViewModel interface.
 */
export function instanceOfInvestmentComponentsViewModel(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function InvestmentComponentsViewModelFromJSON(json: any): InvestmentComponentsViewModel {
    return InvestmentComponentsViewModelFromJSONTyped(json, false);
}

export function InvestmentComponentsViewModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): InvestmentComponentsViewModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'vestedComponentNonVestedRights': !exists(json, 'VestedComponentNonVestedRights') ? undefined : json['VestedComponentNonVestedRights'],
        'nonVestedComponent': !exists(json, 'NonVestedComponent') ? undefined : json['NonVestedComponent'],
        'retirementComponent': !exists(json, 'RetirementComponent') ? undefined : json['RetirementComponent'],
        'savingsComponent': !exists(json, 'SavingsComponent') ? undefined : json['SavingsComponent'],
    };
}

export function InvestmentComponentsViewModelToJSON(value?: InvestmentComponentsViewModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'VestedComponentNonVestedRights': value.vestedComponentNonVestedRights,
        'NonVestedComponent': value.nonVestedComponent,
        'RetirementComponent': value.retirementComponent,
        'SavingsComponent': value.savingsComponent,
    };
}

